<template>
  <main>
    <section>
      <v-row no-gutters>
        <v-col
          class="main-bg show-mobile"
          cols="12"
          lg="8"
          md="7"
          sm="12"
          xl="8"
          xs="6"
        >
          <div class="bg-shadow">
            <v-img :src="loginBg" contain height="100vh" width="auto"></v-img>
          </div>
          <div class="overlay-cover"></div>
        </v-col>
        <v-col cols="12" lg="4" md="5" sm="12" xl="4" xs="6">
          <form-login
            :loading="loading"
            :login-data="loginData"
            @loginAccess="signUp"
          ></form-login>
        </v-col>
      </v-row>
    </section>
    <ActionPopUp
      :dialog="dialog"
      :type="type"
      iteName=""
      @closeAction="dialog = false"
    ></ActionPopUp>
  </main>
</template>

<script>
import FormLogin from "@/components/FormLogin.vue";
import { mapActions } from "vuex";
import loginBg from "@/assets/images/psm.png";
import ActionPopUp from "@/components/ActionPopUp.vue";

export default {
  name: "Login",
  components: { ActionPopUp, FormLogin },
  data() {
    return {
      loginData: {
        password: "",
        email: "",
      },
      loading: false,
      dialog: false,
      type: "error",
    };
  },
  computed: {
    loginBg: () => loginBg,
  },
  methods: {
    ...mapActions("auth", ["fetchUser"]),
    async signUp() {
      localStorage.clear();
      this.loading = true;
      const statusLogin = await this.fetchUser(this.loginData);
      this.loading = false;
      if (statusLogin.status !== "failed") {
        this.$router.push("/dashboard");
        return;
      } else {
        this.dialog = true;
      }
    },
  },
};
</script>

<style lang="scss">
.main-bg {
  position: relative;
  height: 100vh;
  background: linear-gradient(90deg, rgba(14,24,53,1) 0%, rgba(21,34,72,1) 35%, rgba(31,45,91,1) 100%);
}
.main-bg .overlay-cover {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  display: block;
  background: rgba(0, 0, 0, 0.1);
}
.bg-shadow {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}
</style>
